import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import "./_instRevisionMaterial.scss";

// Reusable shimmer / skeleton blocks for the Institute Revision Material module.
// Uses the `.rev-shimmer` class defined in _instRevisionMaterial.scss, matching
// the Finance module's skeleton aesthetic.

export const Shimmer = ({ width = "100%", height = 14, radius = 6, style = {} }) => (
    <div className="rev-shimmer" style={{ width, height, borderRadius: radius, ...style }} />
);

// Generic table skeleton (header row + body rows).
export const RevisionTableShimmer = ({ rows = 6, cols = 7 }) => {
    const widths = [90, 110, 130, 150, 60, 60, 60];
    const cells = widths.slice(0, cols);
    return (
        <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 14, padding: "16px 20px" }}>
            <div style={{ display: "flex", gap: 16, padding: "10px 0", borderBottom: "2px solid #f3f4f6", marginBottom: 4 }}>
                {cells.map((w, i) => <Shimmer key={i} width={w} height={13} style={{ flexShrink: 0 }} />)}
            </div>
            {Array.from({ length: rows }).map((_, r) => (
                <div key={r} style={{ display: "flex", gap: 16, padding: "14px 0", borderBottom: "1px solid #f3f4f6", alignItems: "center" }}>
                    {cells.map((w, i) => <Shimmer key={i} width={w} height={12} style={{ flexShrink: 0 }} />)}
                </div>
            ))}
        </div>
    );
};

// Full-page skeleton for the initial load (tab strip + header + filter row + table)
// inside the finance module's tabbed card shell (see FeeStructureHome.jsx).
export const RevisionMaterialShimmer = () => (
    <div style={{ background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px", marginBottom: 100 }}>
        <Container fluid className="px-0">
            <div style={{ background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "visible", border: "1px solid #e2e8f0" }}>
                {/* Tab strip */}
                <div style={{ background: "#f8fafc", borderBottom: "1.5px solid #e2e8f0", padding: "12px 24px 0 24px", borderRadius: "16px 16px 0 0", display: "flex", gap: 8 }}>
                    <Shimmer width={110} height={38} radius={"10px 10px 0 0"} style={{ marginBottom: -1.5 }} />
                    <Shimmer width={150} height={38} radius={"10px 10px 0 0"} style={{ marginBottom: -1.5 }} />
                </div>
                <div style={{ padding: 28 }}>
                    {/* Header */}
                    <div className="mb-3">
                        <Shimmer width={170} height={17} style={{ marginBottom: 8 }} />
                        <Shimmer width={240} height={11} />
                    </div>
                    {/* Filter row */}
                    <Row className="g-3">
                        {[0, 1, 2, 3].map((i) => (
                            <Col xl={3} lg={3} md={6} sm={12} key={i} className="mb-2">
                                <Shimmer width="55%" height={11} style={{ marginBottom: 7 }} />
                                <Shimmer width="100%" height={40} radius={8} />
                            </Col>
                        ))}
                    </Row>
                    {/* Table */}
                    <div style={{ marginTop: 32 }}>
                        <RevisionTableShimmer rows={6} cols={7} />
                    </div>
                </div>
            </div>
        </Container>
    </div>
);

export default RevisionMaterialShimmer;
